module.exports = __webpack_public_path__ + "img/note.3553b186.svg";